<mat-form-field>
  <textarea [(ngModel)]="convertedValue" [attr.rows]="rows" [class.invalid]="!isJSONValid" matInput></textarea>
</mat-form-field>

